import auth from './auth';
import users from './users';
import projects from './projects';
import hours from './hours';
import expenses from './expenses';
import overview from './overview';

export default {
  auth,
  users,
  projects,
  hours,
  expenses,
  overview,
};
